module.exports = __webpack_public_path__ + "img/SLT_0728-Bearbeitet.34650c40.jpg";